import { useEffect, useState } from 'react'
import type { CompetitorReportSummary } from '../../api/types'

function elapsed(since: string, now: number): string {
	const seconds = Math.max(0, Math.round((now - new Date(since).getTime()) / 1000))
	return seconds < 60 ? `${seconds}s` : `${Math.floor(seconds / 60)}m ${String(seconds % 60).padStart(2, '0')}s`
}

/** A running report's progress bar, what it's doing now, and how long it has been going. */
export function ReportProgress({ report }: { report: CompetitorReportSummary }) {
	const [now, setNow] = useState(Date.now())
	useEffect(() => {
		const timer = setInterval(() => setNow(Date.now()), 1000)
		return () => clearInterval(timer)
	}, [])
	const fraction = report.progress?.fraction ?? 0
	const message = report.status === 'pending' ? 'Waiting to start…' : (report.progress?.message ?? 'Starting…')
	return (
		<div className="stack" style={{ gap: '0.5rem', padding: '1rem 0' }}>
			<div
				className="progress-track"
				role="progressbar"
				aria-label="Competitor report progress"
				aria-valuemin={0}
				aria-valuemax={100}
				aria-valuenow={Math.round(fraction * 100)}
			>
				<div className="progress-fill" style={{ width: `${Math.max(2, fraction * 100)}%` }} />
			</div>
			<div className="row small" style={{ justifyContent: 'space-between' }}>
				<span>{message}</span>
				<span className="muted">
					{Math.round(fraction * 100)}% · {elapsed(report.createdAt, now)}
				</span>
			</div>
		</div>
	)
}
